import { getHapu } from "./hapu";
import { request } from "./api";

export const getMarae = async () => {
    const groups = await request.get("/groups?tenant=RANGI");
    const hapu = await getHapu();

    const getMarae = (name) => {
        const m = groups.marae.find(({ value }) => value === name);

        if (!m) {
            console.error(name, groups.marae);
            throw new Error(`Could not find get marae ${name}`);
        }

        return m.value;
    };

    return {
        Raketapauma: {
            description: getMarae("Raketapauma"),
            id: 633020,
            hapu: [hapu.Rangituhia],
        },
        Kuratahi: {
            description: getMarae("Kuratahi"),
            id: 633022,
            hapu: [hapu.Rangituhia, hapu.Parenga],
        },
        "Te Ao Hou": {
            description: getMarae("Te Ao Hou"),
            id: 633024,
            hapu: [hapu.Tupoho, hapu["Rangi-ki-tai"]],
        },
        Tirorangi: {
            description: getMarae("Tirorangi"),
            id: 633026,
            hapu: [hapu.Tongaiti, hapu.Rangiteauria],
        },
        Tirohia: {
            description: getMarae("Tirohia"),
            id: 633025,
            hapu: [hapu.Hioi],
        },
        Mokai: {
            description: getMarae("Ngā Mōkai"),
            id: 633030,
            hapu: [hapu.Tongaiti],
        },
        Maungarongo: {
            description: getMarae("Maungārongo"),
            id: 633032,
            hapu: [hapu["Tui-o-Nuku"]],
        },
        Mangamingi: {
            description: getMarae("Mangamingi"),
            id: 633027,
            hapu: [hapu.Tamakana, hapu.Uenuku],
        },
        "Tuhi Ariki": {
            description: getMarae("Tuhi Ariki"),
            id: 633028,
            hapu: [hapu["Tuhi Ariki"]],
        },
        Raetihi: {
            description: getMarae("Raetihi (Te Puke)"),
            id: 633031,
            hapu: [hapu.Uenukumanawawiri, hapu.Uenuku],
        },
        Marangai: {
            description: getMarae("Marangai"),
            id: 633023,
            hapu: [hapu.Uenukumanawawiri],
        },
        Motekatoa: {
            description: getMarae("Mote Katoa"),
            id: 633033,
            hapu: [hapu.Uenuku, hapu.Patutokotoko],
        },
        Waitahuparae: {
            description: getMarae("Waitahuparae"),
            id: 633029,
            hapu: [hapu.Uenukumanawawiri, hapu.Patutokotoko],
        },
    };
};
